@if (currentUser()) {
  @if (displayMode === 'OVERLAY') {
    <ng-container *ngTemplateOutlet="openerTemplate" />
  } @else {
    <ftr-dropdown-menu [menuItems]="menuItems()" data-track-group="Public Side Nav User Dropdown">
      <ng-container *ngTemplateOutlet="openerTemplate" />
    </ftr-dropdown-menu>
  }
}

<ng-template #openerTemplate>
  <button
    class="user-and-org-dropdown"
    aria-label="Open user menu"
    (click)="displayMode === 'OVERLAY' ? dropdownOpened.emit(menuItems()) : toggle()"
    (keydown.enter)="displayMode === 'OVERLAY' ? dropdownOpened.emit(menuItems()) : toggle()"
  >
    @if (currentOrganization()) {
      <ng-container *ngTemplateOutlet="organizationTemplate" />
    } @else {
      <ng-container *ngTemplateOutlet="userTemplate" />
    }
  </button>
</ng-template>

<ng-template #userTemplate>
  @if (collapsed) {
    <ftr-user-avatar [user]="currentUser()" [size]="24" [static]="true" />
  } @else {
    <div class="user-and-org-dropdown__user">
      <ftr-user-avatar [user]="currentUser()" [size]="24" [static]="true" />
      <div class="user-and-org-dropdown__name">{{ currentUser()!.givenName }} {{ currentUser()!.familyName }}</div>
    </div>
    <svg [ftrIcon]="displayMode === 'OVERLAY' ? 'ChevronRight' : 'ChevronDown'" [iconSize]="18" />
  }
</ng-template>

<ng-template #organizationTemplate>
  @if (collapsed) {
    <svg ftrIcon="Group" iconColor="Grey40" [iconSize]="24" />
  } @else {
    <div class="user-and-org-dropdown__user">
      <svg ftrIcon="Group" iconColor="Grey40" [iconSize]="24" />
      <div class="user-and-org-dropdown__name">{{ currentOrganization()?.name }}</div>
    </div>
    <svg [ftrIcon]="displayMode === 'OVERLAY' ? 'ChevronRight' : 'ChevronDown'" [iconSize]="18" />
  }
</ng-template>
